import { createMuiTheme } from '@material-ui/core';

const black = '#000000';

const inputErrorTextStyles = {
  '& + .ee-input-error-text': {
    fontSize: 12,
    color: '#af292e',
    position: 'absolute',
    bottom: -18,
  },
  '&.Mui-error': {
    border: '1px solid #af292e',
  },
};

const palette = {
  palette: {
    primary: {
      contrastText: '#ffffff',
      dark: '#37465b',
      main: '#455772',
      light: '#5d7599',
      disabled: '#d7dde6',
    },
    secondary: {
      contrastText: '#455772',
      dark: '#e6e6e6',
      main: '#ffffff',
      light: '', // NEEDED
    },
    text: {
      primary: '#ffffff',
      secondary: '#385f99',
    },
    grey: {
      600: '#767676',
    },
    error: {
      contrastText: black,
      dark: '', // NEEDED
      main: '#d22c2c',
      light: '', // NEEDED
    },
    disabled: {
      main: '#676767',
    },
  },
  typography: {
    fontFamily: 'Source Sans Pro',
    color: '#2f3b4c',

    h1: {
      fontSize: 40,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: 28,
      lineHeight: 1.14,
    },
    h3: {
      fontSize: 16,
      fonWeight: 600,
      lineHeight: 1.18,
    },
    body1: {
      fontSize: 16,
      lineHeight: 1.25,
    },
    h4: {
      fontSize: 12,
      fonWeight: 600,
      lineHeight: 1.33,
    },
    select: {
      backgroundColor: 'red',
      classes: {
        paper: {
          //
          backgroundColor: 'red',
        },
        list: {
          //
        },
      },
    },
    subtitle1: {
      minWidth: 200,
      marginRight: 10,
      fontSize: 14,
      lineHeight: 3,
    },
  },

  overrides: {
    MuiPaper: {
      root: {
        color: 'inherit',
      },
    },
    MuiButton: {
      root: {
        height: 40,
        padding: '12px 16px',
        borderRadius: '2px',
        fontFamily: 'Source Sans Pro',
        fontSize: '12px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.33,
        letterSpacing: 1,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      },
      containedPrimary: {
        backgroundColor: '#5d7599',
        color: '#ffffff',
        '&:hover': {
          backgroundColor: '#455772',
        },
        '&:active': {
          backgroundColor: '#37465b',
        },
        '&:focus': {
          backgroundColor: '#5d7599',
        },
        '&$disabled': {
          backgroundColor: '#d7dde6',
          color: '#ffffff',
        },
      },
      containedSecondary: {
        border: 'solid 2px #385f99',
        backgroundColor: '#ffffff',
        color: '#385f99',
        padding: '10px 14px',
        '&:hover': {
          backgroundColor: '#ebeef2',
        },
        '&:active': {
          backgroundColor: '#e6e6e6',
        },
        '&:focus': {
          backgroundColor: '#ffffff',
        },
        '&$disabled': {
          border: 'solid 2px #cdd7e5',
          backgroundColor: '#ffffff',
          color: '#cdd7e5',
        },
      },
      outlined: {
        border: 'solid 2px #385f99',
        padding: '12px 16px',
        color: '#5d7599',
        '&:hover': {
          backgroundColor: '#ebeef2',
          color: '#294772',
        },
      },
      outlinedPrimary: {
        border: 'solid 2px transparent',
        color: '#5d7599',
        '&:hover': {
          border: 'solid 2px #385f99',
          backgroundColor: '#ebeef2',
          color: '#294772',
        },
        '&:active': {
          border: 'solid 2px #385f99',
          backgroundColor: '#e6e6e6',
          color: '#21395b',
        },
        '&:focus': {
          border: 'solid 2px #385f99',
          backgroundColor: '#e6e6e6',
          color: '#21395b',
        },
        '&$disabled': {
          border: 'solid 2px transparent',
          color: '#cdd7e5',
        },
      },
      outlinedSecondary: {
        color: '#5d7599',
        '&:hover': {
          border: 'solid 2px #385f99',
          backgroundColor: '#ebeef2',
          color: '#294772',
        },
        '&:active': {
          border: 'solid 2px #385f99',
          backgroundColor: '#e6e6e6',
          color: '#21395b',
        },
        '&:focus': {
          border: 'solid 2px #385f99',
          backgroundColor: '#e6e6e6',
          color: '#21395b',
        },
        '&$disabled': {
          border: 'solid 2px transparent',
          color: '#cdd7e5',
        },
      },
      textPrimary: {
        color: '#5d7599',
      },
      textSecondary: {
        color: '#385f99',
      },
      textSizeSmall: {
        // height: 20,
      },
    },
    MuiChip: {
      root: {
        height: 'auto',
        whiteSpace: 'wrap',
        fontSize: 16,
        backgroundColor: 'rgba(30, 30, 30, 0.12)',
        '&:hover': {
          backgroundColor: 'rgba(30, 30, 30, 0.2)',
        },
        '&:active': {
          backgroundColor: 'rgba(30, 30, 30, 0.3)',
        },
        '&:focus': {
          backgroundColor: 'rgba(30, 30, 30, 0.3)',
        },
      },
      label: {
        whiteSpace: 'wrap',
      },
      deleteIcon: {
        color: 'black',
      },
    },

    MuiSelect: {
      root: {
        height: 40,
        borderRadius: 4,
        borderWidth: 0,
        minWidth: 150,
        width: '100%',
        fontSize: 16,
        lineHeight: 1.25,
      },
      icon: {
        color: '#57759c',
        right: 10,
      },
      selectMenu: {
        padding: '4px 4px 4px 16px',
        minWidth: 120,
        backgroundColor: '#fff',
        '&:focus': {
          backgroundColor: '#fff',
        },
      },
      select: {
        paddingRight: '36px !important',
      },
    },
    MuiInput: {
      root: {
        display: 'flex',
        minHeight: 40,
        minWidth: 80,
        borderRadius: 4,
        backgroundColor: '#ffffff',
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: 'normal',
        color: '#333333',
        borderColor: '#fff',
        ...inputErrorTextStyles,
      },
      input: {
        padding: '0 16px',
      },
      inputTypeSearch: {
        paddingRight: '12px !important',
      },
      underline: {
        '&:before, &:after': { content: 'none' },
      },
    },
    MuiInputBase: {
      root: {
        borderColor: '#fff',
      },
      inputAdornedStart: {
        paddingLeft: 0,
      },
    },
    MuiInputAdornment: {
      root: {
        color: '#676767',
        fontWeight: 300,
      },
      positionStart: {
        '& + input': {
          paddingLeft: 0,
        },
        marginLeft: 8,
      },
    },
    MuiAutocomplete: {
      root: {
        position: 'relative',
        '& p.Mui-error': {
          position: 'absolute',
          left: 0,
          bottom: -18,
          color: '#af292e',
        },
      },
      inputRoot: {
        height: 'auto',
      },
      input: {
        paddingLeft: '16px !important',
      },
      popupIndicator: {
        marginRight: 7,
      },
      endAdornment: {
        right: 10,
      },
      tag: {
        paddingTop: 4,
        paddingBottom: 4,
      },
    },
    MuiCheckbox: {
      root: {
        padding: 0,
      },
    },
    MuiDrawer: {
      paper: {
        boxShadow: '-3px 2px 7px 0 rgba(0, 0, 0, 0.24)',
        backgroundColor: '#f0f0f0',
        padding: '48px 36px',
        minWidth: 580,
        maxWidth: 580,
      },
    },
    MuiMenu: {
      paper: {
        transitionDuration: '0s !important',
        marginTop: 6,
      },
    },
    MuiMenuItem: {
      root: {
        minHeight: 40,
      },
    },
    MuiOutlinedInput: {
      root: {
        '&:hover $notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.40)',
        }
      },
      notchedOutline: {
      },
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 30,
      },
    },
    MuiDialogTitle: {
      root: {
        height: 64,
      },
    },
    MuiDialogContent: {
      root: {
        borderTop: '2px solid #e6e6e6',
        borderBottom: '2px solid #e6e6e6',
      },
    },
    MuiDialogActions: {
      root: {
        height: 64,
        paddingLeft: 24,
        paddingRight: 24,
      },
    },
    // table start
    MuiTableRow: {
      root: {
        '&.tr-hoverable:hover td': {
          backgroundColor: '#eff0f1',
        },
        '& td > .tr-actions': {
          display: 'none',
          position: 'absolute',
          right: 4,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1,
          backgroundColor: '#eff0f1',
          height: '100%',
          alignItems: 'center',
          paddingLeft: 4,
        },
        '&:hover td > .tr-actions': {
          display: 'flex',
        },
      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: '#e6e6e6',
        padding: '7px 16px 13px 16px',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: 1.75,
        color: '#676767',
        height: 48,
        whiteSpace: 'nowrap',
      },
      body: {
        padding: '7px 16px 5px 16px',
        fontSize: 16,
        height: 47,
        borderBottom: 'solid 1px #e6e6e6',
        color: '#1e1e1e',
      },
    },
    // table end
    MuiDivider: {
      root: {
        backgroundColor: '#e6e6e6',
        margin: '12px 0',
      },
    },
    MuiFormControl: {
      root: {
        verticalAlign: 'middle',
      },
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: 0,
        marginRight: 0,
        marginBottom: -2,
      },
      label: {
        fontSize: 14,
      },
    },
    MuiRadio: {
      colorSecondary: {
        '&.Mui-checked': {
          color: '#2f3b4d',
        },
      },
    },
    // DatePicker start
    MuiPickersDay: {
      day: {
        color: 'initial',
      },
    },
    MuiPickersModal: {
      dialog: {
        borderTop: 'none',
        borderBottom: 'none',
      },
    },
  },
};

// FixMe
export default createMuiTheme(palette as any);
